export default "__VITE_ASSET__6VQ5KqT1__"